import TradeApi from '../../api/src/trade/api/TradeApi'
import RoomApi from '../../api/src/room/api/RoomApi'
import moment from 'moment'
const tradeApi = new TradeApi();
const roomApi = new RoomApi();
const state = {
    order: {},
    payedHistory: {},
    list: []
  };

const  mutations =  {
    overGetHistoryPayed (state, payload) {
        if(payload && payload.list){
          payload.list.map(item => {item.payTime = moment(item.payTime).format('YYYY-MM-DD HH:mm:ss')})
          state.list = state.list.concat(payload.list)
          state.payedHistory = payload
        }
      },
    clearHistory() {
      state.payedHistory = {},
      state.list = []
    }
  }

const actions = {
  async getOrder ({ commit }, { data }) {
    let resp = await tradeApi.unifiedOrder(data);
    return resp;
  },
  async getHistoryPayed ({ commit }, { data }) {
    let resp = await tradeApi.findPagingTrade(data.page)
    commit('overGetHistoryPayed', resp)
  }
}

  export default {
    namespaced: true,
    state,
    actions,
    mutations
  }